import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
    Attributes,
    BundleSet,
    CartData,
    Item,
    ProductItem, ShippingDetails,
} from 'src/app/shared-core/models/cart-data.model';
import { CartParserService } from '../../shared-core/services/cart-parser.service';
import { CartService } from '../../shared-core/services/cart.service';
import { ComponentMessagingService } from 'src/app/shared-core/services/component-messaging.service';
import { Subscription } from 'rxjs';
import { MessageTopicsEnum } from 'src/app/shared-core/models/component-message.model';
import { BundleBuilderComponent } from '../bundle-builder/bundle-builder.component';
import { BundleLineDto } from '../bundle-builder/bundle-builder.model';
import { ToastService } from 'ng-uikit-pro-standard';
@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit, OnDestroy {
  @ViewChild('bundleBuilder') bundleBuilder: BundleBuilderComponent;
  Model: CartData;
  IsWaiting: boolean;

  giftCardRecordId: string;
  giftCardAttributes: Attributes;
  giftCardWebcode: string;
  displayGiftCardEditModal: boolean;

  shippingDetails: ShippingDetails;
  
  html = '<span><i>Tooltip</i> <u>with</u> <b>HTML</b></span>';
  modelSubscription: Subscription;
  productListWaitingSubscription: Subscription;
  messagingSubscription: Subscription;

    public get dropshippedItems(): string[] {
        const fulfillmentStrategy = this.shippingDetails?.ShippingQuote?.FulfillmentStrategy;

        return fulfillmentStrategy?.DropshipQuoteRequiredItems ?? [];
    }

    public get hasShippableItems(): boolean {
        const fulfillmentStrategy = this.shippingDetails?.ShippingQuote?.FulfillmentStrategy;

        return fulfillmentStrategy?.ImmediateShippingAvailableItems?.length > 0
            || fulfillmentStrategy?.UnableToImmediatelyShipItems?.length > 0;
    }

    public get showDropshippingBadge(): boolean {
        return this.dropshippedItems.length > 0 && this.hasShippableItems;
    }
  
  constructor(
    public service: CartService,
    public parser: CartParserService,
    private messaging: ComponentMessagingService,
    private _toastService: ToastService
  ) {}

  ngOnDestroy(): void {
    this.modelSubscription.unsubscribe();
    this.productListWaitingSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.modelSubscription = this.service.ModelSubject.subscribe((model) => {
      this.Model = model;
      this.shippingDetails = model.ShippingDetails;
    });

    this.productListWaitingSubscription = this.service.isLoadingSubject.subscribe((waiting) => {
      this.IsWaiting = waiting;
    });

    this.messagingSubscription = this.messaging.onMessage(MessageTopicsEnum.EditBundleRequest).subscribe((msg) => {
      const bundle = msg.content as BundleSet;
      const lines: BundleLineDto[] = bundle.Items.map((i) => {
        return {
          BundleId: bundle.BundleId,
          Webcode: i.Webcode,
          Quantity: i.Quantity
        } as BundleLineDto;
      });

      const highestPricedItem = bundle.Items.sort((a, b) => b.UnitPrice - a.UnitPrice)[0];
      this.bundleBuilder.bundleId = highestPricedItem.Attributes.BundleId;
      this.bundleBuilder.anchorWebcode = highestPricedItem.Webcode;
      this.bundleBuilder.bundleLines = lines;
      this.bundleBuilder.show = true;
    });
  }

  public getImageURL(imgURI: string) {
    if (!imgURI) return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
    return 'https://img.vistek.net' + imgURI[0];
  }

  public changeItemQuantity(item: ProductItem) {
    if (['Used', 'Demo', 'Open Box', 'Refurbished'].includes(item.ItemStatus)) {
      this._toastService.error('Unable to increase quantity for Used, Demo, Open Box, or Refurbished items.', '', {
        timeOut: 6000
      });
      return;
    }

    if (item.Quantity < 1) {
      item.Quantity = 1;
      return;
    }
    this.service.changeItemQuantity(item);
  }
  public saveItemForLater(item: Item) {
    this.service.saveItemForLater(item);
  }
  public removeItem(item: Item) {
    this.service.removeOrderItem(item);
  }

  public onBundleUpdated(bundleId: number) {
    this.service.reloadShoppingCart(true);
  }

  public onGiftCardUpdated(show: boolean) {
    this.displayGiftCardEditModal = show;
  }

  public onGiftCartEdit(item: ProductItem) {
    this.giftCardRecordId = item.RecordID;
    this.giftCardAttributes = item.Attributes;
    this.giftCardWebcode = item.Webcode;
    this.displayGiftCardEditModal = true;
  }

  public isQtyLockedSku(item: ProductItem): boolean {
    const lockedSkus = [ 'GIFTVAR', 'EGIFTVAR' ]; // TODO: Make configurable.

    if (item.ParentRecordID) {
      return true;
    }

    if (lockedSkus.includes(item.Webcode)) {
      return true;
    }

    return false;
  }

  public isCustomizableSku(webCode: string) {
    const customizableSkus = [ 'EGIFTVAR', 'GIFTVAR' ]; // TODO: Make configurable.

    return customizableSkus.includes(webCode);
  }
}
